import { render, staticRenderFns } from "./blockAdd.vue?vue&type=template&id=414a2004&"
import script from "./blockAdd.vue?vue&type=script&lang=js&"
export * from "./blockAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports